import { isArray } from 'lodash';
import { type TFunction } from 'react-i18next';

import { systemRoles, type UserRole } from '../constants/user-roles';

export const translateSelectedRoles = (roles: string | UserRole[], t: TFunction<'admin_settings', undefined>): string => {
    if (isArray(roles)) {
        const localizedRoles = roles.filter((role) => systemRoles.includes(role)).map((role) => t(`users.userRoles.${role}`));
        return localizedRoles.join(', ');
    }

    const localizedRoles: UserRole[] = [];
    systemRoles.forEach((role) => {
        if (roles.indexOf(role) !== -1) localizedRoles.push(role);
    });

    if (localizedRoles.length > 0) return translateSelectedRoles(localizedRoles, t);

    return '';
};
